import {useDispatch, useSelector} from "react-redux";
import {lobbyOpenModal, setActivePage, toggleAudio} from "../../../../redux/actions/lobby/actions";
import React from "react";

function DesktopHeaderOptions() {
    const {activePage, rakeRace, audioEnabled} = useSelector(state => state.lobby);
    const dispatch = useDispatch();
    const toggleActivePage = (name) => {
        dispatch(setActivePage({activePage: name}))
    }
    const toggleMuted = () => {
        dispatch(toggleAudio())
    }

    return (
        <ul className="lobby-header-icon-group">
            {rakeRace?.isActive &&
                <li className="header-option--icon"
                    onClick={() => dispatch(lobbyOpenModal({name: 'RakeRace'}))}
                >
                    <i className="icon-rake-race"/>
                </li>}
            <li
                className={`header-option--icon ${!audioEnabled ? 'icon-volOff' : 'icon-vol'}`}
                onClick={() => toggleMuted()}
            />
            <li
                className={`header-option--icon icon-history ${activePage === "History" ? "history-active" : ""}`}
                onClick={() => toggleActivePage('History')}
            />
            <li
                className="header-option--icon icon-settings"
                onClick={(e) => dispatch(lobbyOpenModal({name: 'Settings'}))}>
            </li>
            <li
                className="header-option--icon icon-0"
                onClick={() => dispatch(lobbyOpenModal({name: 'HowToPlay'}))}
            />
        </ul>

    )
}

export default DesktopHeaderOptions